import { en } from './en'
import { fr } from './fr'

export const volunteerActivityPage = {
  en,
  fr,
}
